import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignedContract = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 462,
	height: 317,
	viewBox: "0 0 462 317",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 175.485C-6.1751e-05 203.371 23.2997 269.967 73.7001 299.259C125.162 329.168 168.309 304.143 228.997 305.129C274.835 305.875 303.081 319.104 346.39 305.129C407.669 285.357 474.154 251.458 460.099 192.608C450.325 151.682 403.777 152.346 374.818 120.203C345.928 88.1383 349.027 55.0342 313.225 29.6969C235.728 -25.1496 141.214 15.9455 68.9622 76.6623C32.2499 107.513 6.17513e-05 147.599 0 175.485Z",
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6217 195.39L4.38949 184.612L15.8227 180.577L14.6217 195.39Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6217 189.39L18.3895 178.612L29.8227 174.577L28.6217 189.39Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2098 183.159L32.2503 173.122L43.374 168.299L43.2098 183.159Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.4615 176.296L46.892 166.968L57.6901 161.455L58.4615 176.296Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.4615 169.296L60.892 159.968L71.6901 154.455L72.4615 169.296Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.4615 163.296L73.892 153.968L84.6901 148.455L85.4615 163.296Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.4615 156.296L85.892 146.968L96.6901 141.455L97.4615 156.296Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.166 147.895L98.8082 139.641L109.069 133.183L111.166 147.895Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.561 140.04L111.203 131.786L121.464 125.328L123.561 140.04Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.631 121.251L134.196 114.897L143.4 107.005L147.631 121.251Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.118 129.659L124.179 122.35L133.93 115.144L137.118 129.659Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.404 118.587L147.291 105.538L159.378 104.583L154.404 118.587Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M291.219 98.2552L282.017 86.5857L293.772 83.615L291.219 98.2552Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.219 95.2552L296.017 83.5857L307.772 80.615L305.219 95.2552Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321.219 90.2552L312.017 78.5857L323.772 75.615L321.219 90.2552Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M338.278 84.3963L327.567 74.0945L338.805 69.5445L338.278 84.3963Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.518 274.977C287.801 275.416 286.274 273.79 286.82 272.104L301.081 228.097L334.646 263.432L289.518 274.977Z",
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M289.24 273.887C288.381 274.107 287.617 273.294 287.891 272.45L301.568 230.244L332.51 262.817L289.24 273.887Z",
				stroke: "#CAD0E1",
				strokeOpacity: .05,
				strokeWidth: 2.25
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M286.82 272.104C286.274 273.79 287.801 275.416 289.518 274.977L297.395 272.962C294.106 270.651 291.233 268.281 288.792 266.02L286.82 272.104ZM289.944 262.464C293.042 265.46 296.998 268.745 301.767 271.843L308.715 270.066C301.459 265.688 295.794 260.772 291.842 256.607L289.944 262.464ZM293.036 252.923C297.229 257.615 304.096 263.778 313.401 268.867L320.634 267.017C308.15 260.717 299.459 252.358 295.015 246.816L293.036 252.923ZM296.283 242.902L301.081 228.097L334.646 263.432L325.753 265.707C310.146 258.797 300.046 248.226 296.283 242.902Z",
			fill: "#CAD0E1",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M289.023 273.04C288.958 273.056 288.918 273.05 288.89 273.041C288.855 273.03 288.815 273.007 288.778 272.968C288.742 272.93 288.722 272.888 288.713 272.853C288.706 272.824 288.702 272.783 288.723 272.72L301.947 231.913L330.849 262.339L289.023 273.04Z",
				stroke: "#CAD0E1",
				strokeOpacity: .2,
				strokeWidth: 4
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.54 261.724C333.151 262.093 332.428 262.4 331.1 262.303C329.771 262.206 328.06 261.71 326.056 260.757C322.063 258.858 317.3 255.331 312.79 250.584C308.281 245.837 305.003 240.899 303.311 236.813C302.463 234.763 302.055 233.029 302.026 231.697C301.997 230.365 302.341 229.659 302.73 229.289C303.119 228.92 303.842 228.612 305.17 228.71C306.5 228.807 308.211 229.303 310.214 230.256C314.208 232.155 318.971 235.682 323.48 240.429C327.99 245.176 331.268 250.114 332.959 254.2C333.808 256.249 334.215 257.984 334.244 259.316C334.273 260.648 333.93 261.354 333.54 261.724Z",
			fill: "#FAFAFC",
			stroke: "#CAD0E1",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.94 239.283L334.566 235.587C335.521 236.23 338.121 237.587 340.871 237.87C344.309 238.223 345.193 234.799 346.076 231.374L346.076 231.374C346.783 228.634 348.364 228.339 349.066 228.534C349.333 228.452 351.178 228.906 356.418 231.375C361.658 233.843 362.343 231.262 362.031 229.662C361.601 225.727 362.848 223.629 363.526 223.072C366.548 221.028 370.955 222.909 372.78 224.105L372.169 227.271C371.643 227.081 370.013 226.526 367.698 225.83C365.382 225.135 363.172 226.51 362.615 227.556C362.439 227.887 362.302 229.404 363.036 231.81C364.584 236.885 359.471 236.403 357.641 235.384C358.076 235.66 357.741 235.598 352.925 233.141C348.109 230.684 346.452 233.947 346.226 235.886C346.289 236.86 345.714 239.267 342.909 241.104C340.104 242.941 335.761 240.656 333.94 239.283Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M324.006 257.03C324.79 254.045 328.369 248.232 336.414 248.863C344.459 249.494 345.039 250.322 344.323 250.657C343.584 251.876 342.377 254.163 342.325 256.175C342.27 258.295 342.909 264.41 350.587 264.872C353.237 264.94 356.624 263.171 354.243 256.746C351.956 250.573 351.517 250.566 350.547 250.551C350.507 250.55 350.466 250.55 350.425 250.549C354.343 249.412 363.449 249.345 368.526 258.173L369.396 255.279C367.471 251.075 360.413 243.646 347.584 247.559C342.869 245.316 332.073 242.334 326.616 248.346C325.338 249.905 322.884 253.236 323.286 254.095L324.006 257.03ZM347.141 251.9C349.147 252.924 353.248 255.716 353.596 258.695C352.323 260.077 349.154 262.294 346.665 260.108C344.381 258.104 343.773 257.57 343.52 256.902C343.428 256.66 343.383 256.399 343.322 256.045C343.137 254.979 345.791 252.838 347.141 251.9Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M313.957 244.373L313.331 248.07C317.032 248.518 323.428 247.268 324.951 239.617C325.005 237.497 325.073 234.847 322.274 230.267C321.078 228.646 319.934 224.321 324.924 219.994L326.8 219.246C326.777 220.13 326.938 222.114 327.765 222.984C327.907 223.134 328.049 223.304 328.196 223.48C329.113 224.579 330.214 225.899 332.779 223.908C335.16 222.06 333.726 218.01 332.711 216.216C332.023 215.491 330.271 214.191 328.77 214.789C330.601 212.361 336.223 207.503 344.073 207.492L344.426 204.054C339.652 204.108 329.57 206.377 327.439 215.02C325.563 215.767 321.622 218.477 320.861 223.337C320.1 228.196 320.761 230.671 321.187 231.3L323.456 235.866C323.882 236.496 324.565 238.122 323.891 239.59C323.048 241.425 319.746 246.113 313.957 244.373ZM333.146 219.94C332.639 219.043 330.82 217.599 327.602 219.002C328.091 220.605 329.885 223.038 333.146 219.94Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.315 236.822L309.41 233.112C311.313 233.373 313.265 231.001 314.004 229.783C314.254 228.304 311.191 225.733 309.628 224.632C305.745 222.529 304.595 219.072 304.505 217.606C304.005 212.289 307.459 209.285 309.248 208.447C312.031 207.457 313.126 205.452 313.325 204.574C313.347 203.726 310.571 201.674 309.181 200.755L309.534 197.317C311.632 198.219 313.153 200.945 313.651 202.195C315.217 207.327 312.555 210.476 311.028 211.409C309.416 212.252 306.073 214.358 305.606 216.043C305.138 217.728 307.286 219.445 308.419 220.093C311.137 221.648 312.668 223.296 313.093 223.925C317.746 232.743 312.513 236.197 309.315 236.822Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M357.818 218.152L355.277 213.844L361.76 209.237L363.798 212.472L357.818 218.152Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M390.877 241.605L393.611 237.416L400.615 241.182L398.621 244.443L390.877 241.605Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.384 165.496L366.843 161.188L373.326 156.581L375.364 159.815L369.384 165.496Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M366.612 192.95L362.061 195.025L358.16 188.096L361.59 186.408L366.612 192.95Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M407.302 194.155L403.802 190.583L408.99 184.555L411.744 187.206L407.302 194.155Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310.357 173.73L307.815 169.422L314.298 164.816L316.336 168.05L310.357 173.73Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M319.386 185.196L320.624 180.35L328.468 181.659L327.631 185.389L319.386 185.196Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 165.872L333.238 161.027L341.082 162.335L340.245 166.065L332 165.872Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M326.617 194.015L323.152 194.722L324.823 201.925L329.62 200.987L326.617 194.015Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M402.183 218.359L398.718 219.066L400.389 226.268L405.186 225.331L402.183 218.359Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M386.564 183.029L386.487 186.565L393.881 186.526L394.027 181.64L386.564 183.029Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M338.183 141.359L334.718 142.066L336.389 149.268L341.186 148.331L338.183 141.359Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M314.183 140.359L310.718 141.066L312.389 148.268L317.186 147.331L314.183 140.359Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M395.52 202.017L393.17 199.374L387.779 204.435L390.998 208.113L395.52 202.017Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M352.479 176.697L350.129 174.055L344.738 179.116L347.957 182.794L352.479 176.697Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M298.554 202.576L293.499 203.242L296.488 210.743L299.682 210.295L298.554 202.576Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 186C31.2734 175.999 101.576 146.028 144.602 106.158C192.295 102.599 298.945 89.7831 344 67.0002",
			stroke: "#E2E5EF",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 312.75,
			y1: 306.347,
			x2: 312.75,
			y2: 308.882,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 312.75,
			y1: 311.061,
			x2: 312.75,
			y2: 313.597,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 309.214,
			y1: 310.061,
			x2: 311.75,
			y2: 310.061,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 313.928,
			y1: 310.061,
			x2: 316.464,
			y2: 310.061,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 115,
			cy: 106,
			r: 3,
			stroke: "#CAD0E1",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 257,
			cy: 54.0002,
			r: 5,
			stroke: "#CAD0E1",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 200,
			r: 5,
			stroke: "#CAD0E1",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 325.036,
			y1: 105.5,
			x2: 325.036,
			y2: 108.036,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 325.036,
			y1: 110.214,
			x2: 325.036,
			y2: 112.75,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 321.5,
			y1: 109.214,
			x2: 324.035,
			y2: 109.214,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 326.214,
			y1: 109.214,
			x2: 328.75,
			y2: 109.214,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 398.785,
			y1: 152.5,
			x2: 398.785,
			y2: 155.036,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 398.785,
			y1: 157.215,
			x2: 398.785,
			y2: 159.75,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 395.25,
			y1: 156.215,
			x2: 397.785,
			y2: 156.215,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 399.964,
			y1: 156.215,
			x2: 402.5,
			y2: 156.215,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_156_2212)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M160.214 85.9184C160.214 83.7093 162.005 81.9184 164.214 81.9184H271.333C272.4 81.9184 273.422 82.3443 274.173 83.1015L283 92.0004L292.236 101.331C292.977 102.08 293.393 103.092 293.393 104.145V247.633C293.393 249.842 291.602 251.633 289.393 251.633H164.214C162.005 251.633 160.214 249.842 160.214 247.633V85.9184Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 221.5,
			y1: 172.5,
			x2: 269.5,
			y2: 172.5,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 221.5,
			y1: 162.5,
			x2: 269.5,
			y2: 162.5,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 222.5,
			y1: 181.5,
			x2: 248.5,
			y2: 181.5,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 186.5,
			y1: 108.5,
			x2: 219.915,
			y2: 108.5,
			stroke: "#031A6B",
			strokeOpacity: .5,
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 185.5,
			y1: 122.465,
			x2: 269.5,
			y2: 122.465,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 186.63,
			y1: 131.5,
			x2: 233.344,
			y2: 131.5,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 231.5,
			y1: 231.5,
			x2: 270.5,
			y2: 231.5,
			stroke: "#B3BAD3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.39 220.647C267.758 220.977 266.993 220.556 266.932 219.845L266.494 214.734C266.426 213.938 267.272 213.387 267.972 213.772L272.96 216.514C273.66 216.898 273.649 217.908 272.94 218.277L268.39 220.647Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 298.694,
			y: 154.001,
			width: 9.42857,
			height: 68.3571,
			rx: 2,
			transform: "rotate(28.7957 298.694 154.001)",
			fill: "#FFB484"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M301.793 155.704L305.204 157.579C306.172 158.111 306.526 159.327 305.994 160.295L274.994 216.694C274.462 217.662 273.246 218.015 272.278 217.483L271.965 217.311L301.793 155.704Z",
			fill: "#F29559"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M268.567 219.824C267.518 219.994 266.703 220.789 267.253 221.105L268.695 221.931C268.923 222.062 269.309 222.058 269.702 221.959C269.764 222.287 270.112 222.522 270.713 222.577L288.759 224.216C289.859 224.316 291.392 223.772 292.183 223.001L292.807 222.393C293.598 221.622 293.348 220.916 292.248 220.816L274.201 219.177C273.6 219.123 272.87 219.26 272.202 219.522C272.063 219.374 271.749 219.307 271.316 219.378L268.567 219.824Z",
			fill: "black",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237 225.894C239.921 224.904 241.845 222.18 243.477 220.083C246.662 215.987 248.862 211.471 249.458 206.595C249.487 206.361 249.504 205.697 249.352 205.895C248.638 206.819 248.393 208.197 248.078 209.228C246.814 213.36 245.666 217.618 245.954 221.912C246.097 224.043 247.58 223.055 248.856 222C251.253 220.02 253.737 217.753 255.457 215.319C255.548 215.19 256.037 213.931 255.749 214.582C254.876 216.557 253.94 218.501 253.67 220.614C253.582 221.303 253.065 223.598 254.041 224.08C255.404 224.753 257.275 222.628 257.908 221.971C259.009 220.826 259.897 219.539 260.377 218.121C260.397 218.061 260.164 219.485 260.093 219.803C259.869 220.818 258.38 225.935 261.403 225.437C263.867 225.031 264.908 222.677 266.464 221.381",
			stroke: "#031A6B",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.642 242.752C201.685 232.972 198.042 223.425 193.746 214.182C189.45 204.939 193.359 212.369 187.79 203.802C189.896 203.792 191.648 205.126 193.768 205.172C194.65 203.242 195.047 199.694 195.882 197.727C201.724 206.715 198.879 200.005 203.386 209.702C207.892 219.399 211.714 229.415 214.817 239.675C212.775 239.045 210.733 238.444 208.69 237.873C207.358 239.523 206.008 241.15 204.642 242.752Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.477 204.095C196.318 212.915 200.679 204.108 196.824 213.543C192.968 222.978 189.779 232.686 187.285 242.595C185.845 241.058 184.421 239.497 183.012 237.912C180.999 238.578 178.987 239.275 176.977 240.001C179.593 229.605 182.939 219.421 186.983 209.522C191.028 199.623 186.889 207.981 192.302 198.728C193.228 200.653 194.176 202.56 195.147 204.446C197.263 204.3 199.373 204.183 201.477 204.095Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.976 233.962C193.942 233.957 192.29 231.296 190.414 230.788C188.475 230.263 185.708 231.709 184.01 230.719C182.289 229.716 182.184 226.587 180.788 225.184C179.391 223.78 176.262 223.659 175.268 221.933C174.287 220.23 175.747 217.471 175.231 215.529C174.732 213.65 172.08 211.986 172.085 209.951C172.09 207.917 174.751 206.266 175.259 204.39C175.784 202.45 174.338 199.684 175.328 197.986C176.331 196.265 179.46 196.16 180.864 194.763C182.267 193.366 182.388 190.237 184.114 189.243C185.817 188.262 188.576 189.722 190.518 189.206C192.397 188.708 194.061 186.055 196.096 186.06C198.13 186.065 199.781 188.726 201.658 189.234C203.597 189.76 206.363 188.314 208.061 189.303C209.783 190.306 209.888 193.435 211.284 194.839C212.681 196.242 215.809 196.363 216.804 198.089C217.785 199.792 216.325 202.551 216.841 204.493C217.34 206.372 219.992 208.037 219.987 210.071C219.982 212.105 217.321 213.756 216.813 215.633C216.288 217.572 217.734 220.339 216.744 222.036C215.741 223.758 212.612 223.863 211.208 225.26C209.805 226.656 209.684 229.784 207.958 230.779C206.255 231.76 203.496 230.3 201.554 230.816C199.675 231.315 198.011 233.967 195.976 233.962Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.804 198.089C215.809 196.362 212.798 196.366 211.284 194.838C211.284 194.838 217.325 210.443 209.702 218.028C207.557 220.163 203.602 224.916 197.136 225.98C190.17 227.127 181.17 225.56 181.17 225.56C181.696 225.955 182.3 229.745 184.198 230.89C185.586 231.765 188.964 230.444 190.661 230.906C191.68 231.184 194.075 233.956 195.976 233.962C198.011 233.967 199.675 231.314 201.554 230.815C203.496 230.3 206.255 231.759 207.958 230.778C209.684 229.784 209.805 226.655 211.208 225.259C212.612 223.863 215.741 223.757 216.744 222.036C217.734 220.338 216.288 217.571 216.813 215.632C217.321 213.755 219.982 212.104 219.987 210.07C219.992 208.036 217.34 206.371 216.841 204.493C216.325 202.551 217.785 199.791 216.804 198.089Z",
			fill: "#47998D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.076 193.828C187.143 193.805 179.875 201.037 179.853 209.97C179.83 218.904 187.062 226.172 195.995 226.194C204.928 226.216 212.197 218.984 212.219 210.051C212.241 201.118 205.009 193.85 196.076 193.828ZM196.003 222.957C188.867 222.939 183.071 217.115 183.089 209.979C183.107 202.842 188.931 197.047 196.068 197.064C203.205 197.082 209 202.906 208.982 210.043C208.964 217.18 203.14 222.975 196.003 222.957ZM202.33 204.023L192.79 213.514L189.755 210.464C189.126 209.832 188.106 209.829 187.474 210.459C186.841 211.088 186.838 212.108 187.468 212.741L191.649 216.942C192.279 217.575 193.298 217.578 193.931 216.948L204.622 206.31C205.255 205.68 205.257 204.661 204.628 204.028C203.998 203.396 202.962 203.393 202.33 204.023Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_156_2212)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M273 102L293 103L272 82.0003L273 102Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 320.903,
			y1: 113.707,
			x2: 312.707,
			y2: 121.996,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 394.904,
			y1: 160.361,
			x2: 386.707,
			y2: 168.65,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 74.1213,
			y1: 94.0447,
			x2: 79.7782,
			y2: 99.7016,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 84.728,
			y1: 104.651,
			x2: 90.3849,
			y2: 110.308,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 74.8284,
			y1: 110.308,
			x2: 80.4852,
			y2: 104.651,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 85.4351,
			y1: 99.7017,
			x2: 91.0919,
			y2: 94.0449,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 57.5489,
			y1: 138.166,
			x2: 32.1213,
			y2: 163.765,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 65.5489,
			y1: 119.166,
			x2: 40.1213,
			y2: 144.765,
			stroke: "#CAD0E1",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 319.902,
			y1: 117.707,
			x2: 305.707,
			y2: 131.998,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 393.902,
			y1: 164.361,
			x2: 379.707,
			y2: 178.652,
			stroke: "#CAD0E1",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98 74.0004C98 74.0004 102.215 73.3205 104.01 71.5256C105.805 69.7306 106.485 65.5151 106.485 65.5151C106.485 65.5151 107.165 69.7306 108.96 71.5256C110.755 73.3205 114.971 74.0004 114.971 74.0004C114.971 74.0004 110.755 74.6804 108.96 76.4753C107.165 78.2702 106.485 82.4857 106.485 82.4857C106.485 82.4857 105.805 78.2702 104.01 76.4753C102.215 74.6804 98 74.0004 98 74.0004Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121 85.4855C121 85.4855 125.215 84.8056 127.01 83.0107C128.805 81.2157 129.485 77.0003 129.485 77.0003C129.485 77.0003 130.165 81.2157 131.96 83.0107C133.755 84.8056 137.971 85.4855 137.971 85.4855C137.971 85.4855 133.755 86.1655 131.96 87.9604C130.165 89.7553 129.485 93.9708 129.485 93.9708C129.485 93.9708 128.805 89.7553 127.01 87.9604C125.215 86.1655 121 85.4855 121 85.4855Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171 58.4855C171 58.4855 175.215 57.8056 177.01 56.0107C178.805 54.2157 179.485 50.0003 179.485 50.0003C179.485 50.0003 180.165 54.2157 181.96 56.0107C183.755 57.8056 187.971 58.4855 187.971 58.4855C187.971 58.4855 183.755 59.1655 181.96 60.9604C180.165 62.7553 179.485 66.9708 179.485 66.9708C179.485 66.9708 178.805 62.7553 177.01 60.9604C175.215 59.1655 171 58.4855 171 58.4855Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204 24.4855C204 24.4855 208.215 23.8056 210.01 22.0107C211.805 20.2157 212.485 16.0003 212.485 16.0003C212.485 16.0003 213.165 20.2157 214.96 22.0107C216.755 23.8056 220.971 24.4855 220.971 24.4855C220.971 24.4855 216.755 25.1655 214.96 26.9604C213.165 28.7553 212.485 32.9708 212.485 32.9708C212.485 32.9708 211.805 28.7553 210.01 26.9604C208.215 25.1655 204 24.4855 204 24.4855Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130 46.9708C130 46.9708 138.431 45.6109 142.021 42.0211C145.611 38.4312 146.971 30.0003 146.971 30.0003C146.971 30.0003 148.33 38.4312 151.92 42.0211C155.51 45.6109 163.941 46.9708 163.941 46.9708C163.941 46.9708 155.51 48.3307 151.92 51.9206C148.33 55.5104 146.971 63.9414 146.971 63.9414C146.971 63.9414 145.611 55.5104 142.021 51.9206C138.431 48.3307 130 46.9708 130 46.9708Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204 53.9708C204 53.9708 212.431 52.6109 216.021 49.0211C219.611 45.4312 220.971 37.0003 220.971 37.0003C220.971 37.0003 222.33 45.4312 225.92 49.0211C229.51 52.6109 237.941 53.9708 237.941 53.9708C237.941 53.9708 229.51 55.3307 225.92 58.9206C222.33 62.5104 220.971 70.9414 220.971 70.9414C220.971 70.9414 219.611 62.5104 216.021 58.9206C212.431 55.3307 204 53.9708 204 53.9708Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289 59.0004C289 59.0004 292.974 58.3594 294.667 56.6671C296.359 54.9748 297 51.0003 297 51.0003C297 51.0003 297.641 54.9748 299.334 56.6671C301.026 58.3594 305 59.0004 305 59.0004C305 59.0004 301.026 59.6415 299.334 61.3338C297.641 63.0261 297 67.0006 297 67.0006C297 67.0006 296.359 63.0261 294.667 61.3338C292.974 59.6415 289 59.0004 289 59.0004Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180 282.001C180 282.001 183.974 281.359 185.667 279.667C187.359 277.975 188 274 188 274C188 274 188.641 277.975 190.334 279.667C192.026 281.359 196 282.001 196 282.001C196 282.001 192.026 282.642 190.334 284.334C188.641 286.026 188 290.001 188 290.001C188 290.001 187.359 286.026 185.667 284.334C183.974 282.642 180 282.001 180 282.001Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55 240C55 240 58.9745 239.359 60.6668 237.667C62.3591 235.975 63.0001 232 63.0001 232C63.0001 232 63.6412 235.975 65.3335 237.667C67.0258 239.359 71.0003 240 71.0003 240C71.0003 240 67.0258 240.641 65.3335 242.334C63.6412 244.026 63.0001 248.001 63.0001 248.001C63.0001 248.001 62.3591 244.026 60.6668 242.334C58.9745 240.641 55 240 55 240Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.781 196.152C103.764 203.758 101.328 216.603 94.6474 218.344C87.967 220.085 79.5719 210.063 77.5895 202.456C75.6071 194.85 79.4156 187.272 86.096 185.531C92.7764 183.79 99.799 188.545 101.781 196.152Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.599 190.692C122.117 198.412 114.393 208.959 107.614 207.658C100.834 206.356 97.5654 193.698 99.0474 185.978C100.53 178.258 107.227 173.055 114.007 174.357C120.787 175.659 125.081 182.972 123.599 190.692Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.8379 220L94.3379 218L96.3379 217.5L98.3379 218.5L93.8379 220Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.17 208.805L107.482 207.215L109.503 207.623L110.878 209.386L106.17 208.805Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.3675 199.5C77.8675 192 83.8675 187.5 84.3675 187.5C84.9443 187.225 85.9411 187.052 86.8675 187C86.8675 187.334 86.8675 188.1 84.8675 188.5C82.3675 189 84.0777 192.93 82.3675 193.5C80.8675 194 79.7008 197.667 79.8675 198.5C80.3675 199.167 80.6675 201.6 79.8675 202C79.0675 202.4 78.5008 201.5 78.3675 199.5Z",
			fill: "#EDF2FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.853 186.572C102.421 178.115 109.019 176 112.122 176C115.062 176 117.217 178.769 112.122 178C107.026 177.231 103.994 182.957 102.687 186C101.708 189.845 99.2847 195.029 100.853 186.572Z",
			fill: "#A7B4E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.3379 218.5C90.8379 223 93.465 235.899 93.8379 240C94.3379 245.5 98.8379 275.5 94.8379 286",
			stroke: "#818CB5",
			strokeOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.838 207.5C105.171 218.667 109.838 243.4 111.838 253C113.838 262.6 115.171 279.334 111.838 286.5",
			stroke: "#818CB5",
			strokeOpacity: .25
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_156_2212",
			x: 152.214,
			y: 77.9184,
			width: 149.179,
			height: 185.714,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.319965 0 0 0 0 0.338587 0 0 0 0 0.404167 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_156_2212"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_156_2212",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_156_2212",
			x: 269,
			y: 81.0003,
			width: 27,
			height: 27,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_156_2212"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_156_2212",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgSignedContract);
export { ForwardRef as ReactComponent };
